/* global WeGlideExportURL */

import {Fragment, useCallback} from 'react';
import {connect} from 'react-redux';

import _ from 'topmeteo/utils/i18n';

import CheckboxGroup from 'topmeteo/flight-planning/components/Controls/CheckboxGroup';

import {useSetNotification} from './Notification';

import BaseTab from './BaseTab';
import NameInput from './NameInput';
import NotAvailable from './NotAvailable';
import WeGlideError from './WeGlideError';
import WeGlideNotConnectedMessage from './WeGlideNotConnectedMessage';
import WeGlideSuccessNotification from './WeGlideSuccessNotification';

const ButtonLabel = _('Export');
const PrivateLabel = _('Private');
const DeclareLabel = _('Declare');

const WeGlideTab = ({label, ...props}) => {
    const setNotification = useSetNotification();
    const handleSuccess = useCallback(
        ({id, name}) => {
            setNotification(<WeGlideSuccessNotification id={id} name={name} />);
        },
        [setNotification],
    );

    return (
        <BaseTab {...props} action={WeGlideExportURL} buttonLabel={ButtonLabel} onSuccess={handleSuccess}>
            {error => (
                <Fragment>
                    {error && <WeGlideError error={error} />}
                    <CheckboxGroup id="weglide-private" name="private" label={PrivateLabel} />
                    <CheckboxGroup id="weglide-declare" name="declare" label={DeclareLabel} defaultChecked />
                    <NameInput />
                </Fragment>
            )}
        </BaseTab>
    );
};

const WeGlideTabController = ({isAnonymous, weGlideConnected, ...props}) => {
    if (isAnonymous) return <NotAvailable {...props} />;
    if (weGlideConnected) return <WeGlideTab {...props} />;

    return <WeGlideNotConnectedMessage {...props} />;
};

const mapStateToProps = ({isAnonymous, weGlideConnected}) => ({isAnonymous, weGlideConnected});

export default connect(mapStateToProps)(WeGlideTabController);
